import vm from '../main';
import axios from "axios";

export default function axiosConfig() {
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8';
    axios.defaults.headers.get['Content-Type'] = 'application/json; charset=UTF-8';

    axios.interceptors.request.use((request) => {
        const token = sessionStorage.getItem('api_token');

        if (token) {
            request.headers.Authorization = `Bearer ${token}`;
        }

        request['headers']['common']['Accept'] = '*/*; charset=utf-8';

        return request;
    },
    (error) => {
        return Promise.reject(error);
    });

    axios.interceptors.response.use((response) => {
        if (response.data && response.data.statusCode && !(response.data.statusCode >= 200 && response.data.statusCode < 300))  throw new Error()
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            vm.$router.push({ name: "Logout" });
        }
        else if (error.response.status === 403) {
            vm.$router.push({ name: "Forbidden" });
            vm.$i18n.locale = (localStorage.getItem("lang") ? localStorage.getItem("lang") : vm.$i18n.locale);
        }
        else {
            if (!error.response.request.responseURL.includes('login')) {
                vm.$bvToast.toast(vm.$t("messages.error"), {
                    toaster: "b-toaster-top-center",
                    title: vm.$t("messages.error_title"),
                    autoHideDelay: 7000,
                    variant: "danger",
                });
            }
        }
        return Promise.reject(error.response);
    });
}